import request from "../utils/request";

export function GET_ProjectList(token, payload) {
  return request.get("/Project/List", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_ProjectDetail(token, payload) {
  return request.get("/Project", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function POST_Project(token, payload) {
  return request.post("/Project", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function PUT_Project(token, payload) {
  return request.put("/Project", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function DELETE_Project(token, payload) {
  return request.delete("/Project", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function GET_ProjectMembers(token, payload) {
  return request.get("/Project/Member/List", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function POST_ProjectMember(token, payload) {
  return request.post("/Project/Member", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function DELETE_ProjectMember(token, payload) {
  return request.delete("/Project/Member", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
